var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTensorflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 287,
    viewBox: "0 0 256 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 256,
    height: 287
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.447 0L256 69.7191V133.447L182.468 90.417V122.553L218.962 143.796L219.506 198.809L182.468 177.566V258.179L133.447 286.502V0ZM122.553 0V286.502L73.5319 258.179V90.417L0 133.447V69.7191L122.553 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.447 0L256 69.7191V133.447L182.468 90.417V122.553L218.962 143.796L219.506 198.809L182.468 177.566V258.179L133.447 286.502V0ZM122.553 0V286.502L73.5319 258.179V90.417L0 133.447V69.7191L122.553 0Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 143.251,
    x2: 256,
    y2: 143.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensorflow);
export default __webpack_public_path__ + "static/media/tensorflow.6d6f2e37cd68775a4d2a3c32abce1338.svg";
export { ForwardRef as ReactComponent };